import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { faLock, faLocationCrosshairs } from '@fortawesome/free-solid-svg-icons';
import Spinner from '@src/components/spinner';
import { StatusPage } from '@src/pages/unAuthroizedAccess/statusPage.component';
import { RecordAccessQuery } from '@src/util/query/dataScope.query';

// Wraps a record's detail page (employee, site, customer...). A user whose data
// access is limited to some branches/sites/employees can still be sent a link to
// another one; wfc-server won't return it, so instead of a page that breaks on
// the missing record this says why. Anything but a clear answer shows the page
// as before — wfc-server still guards the data itself.
export const RecordAccessGate = ({ kind, noun, children }) => {
    const { id } = useParams();
    const { data, loading } = useQuery(RecordAccessQuery, {
        variables: { kind, id },
        fetchPolicy: 'network-only',
        skip: !id,
    });

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
                <Spinner />
            </div>
        );
    }

    const access = data?.recordAccess;
    if (access === 'outsideScope') {
        return (
            <StatusPage
                icon={faLock}
                heading="Outside your access"
                message={`You can't open this ${noun} due to your access privileges — it's outside the branches, sites or employees you're allowed to see. Ask your admin if you think you should have access.`}
            />
        );
    }
    if (access === 'notFound') {
        return (
            <StatusPage
                icon={faLocationCrosshairs}
                heading={`${noun.charAt(0).toUpperCase()}${noun.slice(1)} not found`}
                message={`This ${noun} doesn't exist or has been deleted — the link may be out of date.`}
            />
        );
    }
    return children;
};
